import Logo from "./Logo";

export default function Footer() {
    return (
        <footer
            className="relative overflow-hidden border-t border-white/5 px-4 pb-8 pt-10 sm:px-8 lg:px-12"
            data-testid="site-footer"
        >
            <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 sm:flex-row 2xl:max-w-[88rem]">
                <Logo heightClass="h-6" />
                <div className="flex items-center gap-2 text-xs text-dim">
                    <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
                    </span>
                    All systems streaming
                </div>
                <div className="flex items-center gap-6">
                    {["Privacy", "Terms", "Contact"].map((l) => (
                        <a
                            key={l}
                            href="#"
                            data-testid={`footer-link-${l.toLowerCase()}`}
                            className="text-xs text-ghost transition hover:text-ivory"
                        >
                            {l}
                        </a>
                    ))}
                </div>
            </div>
            <div className="pointer-events-none relative z-10 mt-10 select-none text-center text-xs text-ghost">
                © {new Date().getFullYear()} RIVVR — Where great things stream.
                All rights reserved.
            </div>
            <div className="pointer-events-none absolute inset-x-0 bottom-0 select-none text-center font-display text-[24vw] font-black leading-[0.8] text-white/[0.025]">
                RIVVR
            </div>
        </footer>
    );
}
